import React from 'react'
import type { Icon } from 'shared/utils'

const Crustacean = (props: Icon) => {
    const { color = 'black', size = 24, className = 'crustacean' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                d="M16.342 18.358c2.327-8.955-3.451-12.156-3.451-12.156 7.703.225 9.004 9.48 8.98 9.48l-5.529 2.676zm5.578-2.251c0 .025.225 1.5-.25 4.002l-3.877 1.875s-3.752-1.3-5.502-7.603l1.425 1.2.35 1.05.7.426.176.6 1.4 1.15 5.578-2.7zM9.414 2S3.837 5.552 6.688 14.33L1.01 12.006S1.76 2.7 9.414 2zm-.55 10.505l.3-1.076 1.35-1.3c-1.375 6.378-5.027 7.904-5.027 7.904L1.51 16.407c-.625-2.476-.5-3.952-.5-3.952l5.703 2.351 1.326-1.226.15-.6.675-.475z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Crustacean }
